import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../utils/AxiosInstance";
import { Button, Spinner } from "react-bootstrap";

const CategoryDetails = () => {
  const { id } = useParams();
  const [categoryDetails, setCategorydetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchCategory = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`/admin/category/get/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(res);

      if (res.data.data._id) {
        setCategorydetails(res.data.data);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCategory();
  }, [id]);

  if (loading)
    return (
      <div className="text-center my-4">
        <Spinner animation="border" />
      </div>
    );

  if (!categoryDetails)
    return <p className="text-center text-danger">Category not found.</p>;


  return (
    
    <div className="container mt-4">
      <h4 className="mb-4 text-center">Category Details</h4>
      <div className="card p-4">
        <p>
          <strong>Name:</strong> {categoryDetails.name}
        </p>
        <p>
          <strong>Description:</strong> {categoryDetails.description}
        </p>
        <p>
          <strong>Status:</strong>{" "}
          {categoryDetails.isActive ? "Active" : "Inactive"}
        </p>
      </div>
      <div className="mt-4 text-end">
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>
    </div>
  );
};

export default CategoryDetails;
